import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery,
  type UseQueryResult
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { FailureFlagApplication } from 'types/api/failure-flags/failure-flags'

function fetchFailureFlagsApps({
  queryKey: [endpoint, teamId]
}: QueryFunctionContext<ReturnType<typeof failureFlagsQueryKeys.getApps>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })

  return fetchQueryData<FailureFlagApplication[]>(endpointWithParams, {})
}

export function useGetFailureFlagsApps(
  options?: QueryObserverOptions<FailureFlagApplication[], AxiosError>
): UseQueryResult<FailureFlagApplication[]> {
  const { currentTeamId } = useAuth()

  return useQuery<FailureFlagApplication[], AxiosError>({
    ...options,
    queryKey: failureFlagsQueryKeys.getApps(currentTeamId),
    queryFn: fetchFailureFlagsApps
  })
}
